import { useState } from "react";
import { UpdateRequisiteIProps } from "../model/schema";
import { useAvtovazRequisites } from "./useAvtovazRequisites";

interface MutateOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useUpdateRequisite = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const { updateAvtovazRequisite } = useAvtovazRequisites();

  const mutate = async (
    { data, id }: UpdateRequisiteIProps,
    options?: MutateOptions
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    try {
      const result = await updateAvtovazRequisite({ data, id });
      if (result.data) {
        setData(result.data);
        setIsSuccess(true);
        options?.onSuccess?.(result.data);
      } else {
        setError("Не удалось обновить реквизиты");
      }
    } catch (error) {
      setError("Не удалось обновить реквизиты");
      options?.onError?.("Не удалось обновить реквизиты");
    } finally {
      setIsLoading(false);
    }
  };
  return { mutate, isLoading, error, isSuccess, data };
};
